module.exports = __webpack_public_path__ + "img/linhas-caneta-escuro.39bc6725.svg";